import { IndexedDBHelper } from "../classes/storageModel";

export async function loadConfig(){
    return fetch("../configs/configs.json").then((res)=>{
        return res.json();
    }).then((data)=>{        
        return data;
    }).catch((err)=>{
        console.error(err)
    });

}
const dbHelper = new IndexedDBHelper("tfjs_document_quality_classification", "models");
export async function downloadAndsaveModelToDB(modelUrl, key) {
    try {
        await removeModelFromDB(key);
        const response = await fetch(modelUrl, { 
            headers: { "Connection": "keep-alive" } 
        });
        if (!response.ok) throw new Error("Error in Downloading Model");

        const arrayBuffer = await response.arrayBuffer();

        await dbHelper.save(key, arrayBuffer);
        // console.log("Model Downloaded and Saved[IndexedDB]");
        return true;
    } catch (error) {
        console.error("", error);
        return false;
    }
}
async function loadTFliteModelFromDB(model_url,key) {
    try {
        const model = await dbHelper.load(key);
        if (model) {
            return model;
        } else {
            const downloadAndsaveModelResult = await downloadAndsaveModelToDB(model_url,key);
            if (downloadAndsaveModelResult){
                const model = await dbHelper.load(key);
                return model;
            }
            return undefined;
        }
        
    } catch (error) {
        console.error("", error);
        return false;
    }
}

export async function loadTFJSModelFromDB(model_json_url,model_weight_url,key_model_json,key_model_weight) {
    try {
        const model_json = await dbHelper.load(key_model_json);
        const model_weight = await dbHelper.load(key_model_weight);
        if (model_json && model_weight) {
            return [model_json,model_weight];
        } else {
            const downloadAndsaveModelJsonResult = await downloadAndsaveModelToDB(model_json_url,key_model_json);
            const downloadAndsaveModelWeightResult = await downloadAndsaveModelToDB(model_weight_url,key_model_weight);
            if (downloadAndsaveModelJsonResult && downloadAndsaveModelWeightResult){
                const model_json = await dbHelper.load(key_model_json);
                const model_weight = await dbHelper.load(key_model_weight);
                return [model_json,model_weight];
            }
            return undefined;
        }
        
    } catch (error) {
        console.error("", error);
        return false;
    }
}

async function removeModelFromDB(key) {
    try {
        await dbHelper.remove(key);
        // console.log("Model Deleted[IndexedDB]");
        return true;
    } catch (error) {
        console.error("", error);
        return false;
    }
}



// Rotate Canvas
export function rotate(canvas,angle) {
    const rotatedCanvas = document.createElement("canvas");
    const ctx = rotatedCanvas.getContext("2d");
    const radians = angle * (Math.PI / 180);
    rotatedCanvas.width = canvas.height;
    rotatedCanvas.height = canvas.width;
    ctx.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2);
    ctx.rotate(radians);
    ctx.drawImage(canvas, -canvas.width / 2, -canvas.height / 2);
    return rotatedCanvas;
}
